import { IntlShape } from 'react-intl';
import { WrappedFormUtils } from 'antd/es/form/Form';

export function setFieldError(fieldName: string, intlMessageId: string, intl: IntlShape, form: WrappedFormUtils): void {
  form.setFields({
    [fieldName]: {
      value: form.getFieldValue(fieldName),
      errors: [new Error(intl.formatMessage({ id: intlMessageId }))],
    },
  });
}
